import { intervalToDuration, formatDuration } from 'date-fns';
import { ru, enUS } from 'date-fns/locale';
import i18next from 'i18next';

const LOCALES = {
  ru,
  en: enUS,
};

//  'xDays' | 'xHours' | 'xMinutes' | 'xSeconds' - зарезервированные в библиотеке 'date-fns' названия токенов
const formatDistanceLocale = {
  ru: {
    xDays: '{{count}} день',
    xHours: '{{count}} час',
    xMinutes: '{{count}} минута',
    xSeconds: '{{count}} секунда',
  },
  'en-US': {
    xDays: '{{count}} day',
    xHours: '{{count}} hour',
    xMinutes: '{{count}} minute',
    xSeconds: '{{count}} second',
  },
};

export const getTimeOffset = (timeOffset, startTime = 0) => {
  if (typeof startTime !== 'number' || typeof timeOffset !== 'number' || Number.isNaN(startTime) || Number.isNaN(timeOffset)) {
    console.error('getTimeOffset: invalid input data');
    return;
  }

  const currentLanguage = i18next.language;
  const currentLocale = LOCALES[currentLanguage] || ru;

  const timeInterval = intervalToDuration({ start: new Date(startTime * 1000), end: new Date(timeOffset * 1000) });
  const customLocale = {
    /*
    formatDistance - зарезервированная в библиотеке 'date-fns' функция c аргументами для метода formatDuration,
    внутри которой можно писать свою логику
    */
    formatDistance: (token, count) => formatDistanceLocale[currentLocale.code][token].replace('{{count}}', count),
  };

  // eslint-disable-next-line consistent-return
  return formatDuration({
    days: timeInterval.days,
    hours: timeInterval.hours,
    minutes: timeInterval.minutes,
    seconds: timeInterval.seconds,
  }, { locale: customLocale });
};
